import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "onsip-full-web-preview-frame",
  templateUrl: "full-web-preview-frame.component.html",
  styleUrls: ["full-web-preview-frame.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FullWebPreviewFrameComponent {
  @Input() buttonColor!: string;
  @Input() buttonLocation: "right" | "left" = "right";
  @Input() gradientOverlay = false;
  @Input() width!: number;
  @Input() removedOnsipBranding = false;
}
